export enum TextOptions {
    HEADING1 = "heading1",
    HEADING2 = "heading2",
    PARAGRAPH = "paragraph",
    BULLET = "bullet",
    DASH = "dash",
    NUMBERED = "numbered",
    REMOVE_LIST = "removeList",
}

export enum TextFormats {
    BOLD = "bold",
    ITALIC = "italic",
    UNDERLINE = "underline",
}

export enum MediaOptions {
    LINK = "link",
    IMAGE = "image",
}

export enum HistoryOptions {
    UNDO = "undo",
    REDO = "redo",
}

export type RichTextTool = TextOptions | TextFormats | MediaOptions | HistoryOptions;
